<ion-content style="border-top:4px solid #0100ee;" min="0" max="2400" color="white" class="ion-padding profile">
  <!--div class="ion-padding profile__picture">
    img [src]="service?.avatar?.document?.fileName | ppImage">
  </div-->

  <ion-button fill="clear" style="margin-right:0px;" class="ion-float-right" (click)="onCancel()">
    <ion-icon name="close" mode="md"></ion-icon>
  </ion-button>

  <div *ngIf="groupsConfirmationRequired && !someProtectionRequired">

    <h2>{{ 'CONFIRM_TERMS.GROUPS.TITLE' | translate }}</h2>

    <p>{{ 'CONFIRM_TERMS.GROUPS.1_PARAG' | translate : { locationName: real.name | ppTranslate:real.nameTranslations:translateService.currentLang } }}</p>

    <p style="font-weight: bold;">{{ 'CONFIRM_TERMS.GROUPS.2_PARAG' | translate }}</p>

    <p>{{ 'CONFIRM_TERMS.GROUPS.3_PARAG' | translate }}</p>

    <p>{{ 'CONFIRM_TERMS.GROUPS.4_PARAG' | translate }}</p>

    <div class="ion-float-left clickable" style="margin-top:20px;">
      <ion-button style="font-size: 12px;" class="ion-float-right" fill="outline" color="primary" (click)="onCancel();" class="btn--large ion-no-margin">{{ 'CONFIRM_TERMS.GROUPS.BTN_CANCEL' | translate }}</ion-button>
      <p (click)="onCancel();" style="color:blue; text-align: center;">{{ 'CONFIRM_TERMS.GROUPS.UNDER_BTN_LINK' | translate }}</p>
    </div>

    <div class="ion-float-right clickable" style="margin-top:20px;">
      <ion-button style="font-size: 12px;" class="ion-float-right" color="primary" (click)="confirmTerms();" class="btn--large ion-no-margin">{{ 'CONFIRM_TERMS.GROUPS.BTN_OK' | translate }}</ion-button>
    </div>

  </div>

  <div *ngIf="noShowRequired && !groupsConfirmationRequired">

    <h2>{{ 'PAYMENT_INFO.NO_SHOW.TITLE' | translate }}</h2>

    <p>{{ 'PAYMENT_INFO.NO_SHOW.1_PARAG' | translate }}</p>
    <p>{{ 'PAYMENT_INFO.NO_SHOW.2_PARAG' | translate : { noShowMaxPenaltyPerPerson: noShowMaxPenaltyPerPerson } }}</p>
    <h5 style="color: #444444; font-weight: bold;">{{ 'PAYMENT_INFO.NO_SHOW.CANCELATION_TITLE' | translate }}</h5>
    <p style="color: #444444; font-weight: bold;">{{ 'PAYMENT_INFO.NO_SHOW.3_PARAG' | translate : { cancellationPeriodInHours: cancellationPeriodInHours } }}</p>
    <p>{{ 'PAYMENT_INFO.NO_SHOW.4_PARAG' | translate }}</p>
    <p>{{ 'PAYMENT_INFO.NO_SHOW.5_PARAG' | translate }}</p>
    <p>{{ 'PAYMENT_INFO.NO_SHOW.6_PARAG' | translate }}</p>

    <div class="ion-float-left clickable" style="margin-top:20px;">
      <ion-button style="font-size: 12px;" class="ion-float-right" fill="outline" color="primary" (click)="onCancel();" class="btn--large ion-no-margin">{{ 'CONFIRM_TERMS.GROUPS.BTN_CANCEL' | translate }}</ion-button>
      <p style="color:blue; text-align: center;">{{ 'CONFIRM_TERMS.GROUPS.UNDER_BTN_LINK' | translate }}</p>
    </div>

    <div class="ion-float-right clickable" style="margin-top:20px;">
      <ion-button style="font-size: 12px;" class="ion-float-right" color="primary" (click)="confirmTerms();" class="btn--large ion-no-margin">{{ 'CONFIRM_TERMS.GROUPS.BTN_OK' | translate }}</ion-button>
    </div>

  </div>

  <div *ngIf="paymentRequired && !minSpendRequired && !groupsConfirmationRequired">

    <h2>{{ 'PAYMENT_INFO.PAYMENT.TITLE' | translate }}</h2>

    <p>{{ 'PAYMENT_INFO.PAYMENT.1_PARAG' | translate }}</p>
    <p>{{ 'PAYMENT_INFO.PAYMENT.2_PARAG' | translate : { paymentAmount: paymentAmount } }}</p>
    <h5 style="color: #444444; font-weight: bold;">{{ 'PAYMENT_INFO.PAYMENT.CANCELATION_TITLE' | translate }}</h5>
    <p style="color: #444444; font-weight: bold;">{{ 'PAYMENT_INFO.PAYMENT.3_PARAG' | translate : { cancellationPeriodInHours: cancellationPeriodInHours } }}</p>
    <p>{{ 'PAYMENT_INFO.PAYMENT.4_PARAG' | translate }}</p>
    <p>{{ 'PAYMENT_INFO.PAYMENT.5_PARAG' | translate }}</p>
    <p>{{ 'PAYMENT_INFO.PAYMENT.6_PARAG' | translate }}</p>

    <div class="ion-float-left clickable" style="margin-top:20px;">
      <ion-button style="font-size: 12px;" class="ion-float-right" fill="outline" color="primary" (click)="onCancel();" class="btn--large ion-no-margin">{{ 'CONFIRM_TERMS.GROUPS.BTN_CANCEL' | translate }}</ion-button>
      <p style="color:blue; text-align: center;">{{ 'CONFIRM_TERMS.GROUPS.UNDER_BTN_LINK' | translate }}</p>
    </div>

    <div class="ion-float-right clickable" style="margin-top:20px;">
      <ion-button style="font-size: 12px;" class="ion-float-right" color="primary" (click)="confirmTerms();" class="btn--large ion-no-margin">{{ 'CONFIRM_TERMS.GROUPS.BTN_OK' | translate }}</ion-button>
    </div>

  </div>

  <div *ngIf="minSpendRequired && !groupsConfirmationRequired">

    <h2>{{ 'PAYMENT_INFO.MIN_SPEND.TITLE' | translate }}</h2>

    <p>{{ 'PAYMENT_INFO.MIN_SPEND.1_PARAG' | translate }}</p>
    <p>{{ 'PAYMENT_INFO.MIN_SPEND.2_PARAG' | translate : { minSpendAmount: minSpendAmount } }}</p>
    <h5 style="color: #444444; font-weight: bold;">{{ 'PAYMENT_INFO.MIN_SPEND.CANCELATION_TITLE' | translate }}</h5>
    <p style="color: #444444; font-weight: bold;">{{ 'PAYMENT_INFO.MIN_SPEND.3_PARAG' | translate : { cancellationPeriodInHours: cancellationPeriodInHours } }}</p>
    <p>{{ 'PAYMENT_INFO.MIN_SPEND.4_PARAG' | translate }}</p>
    <p>{{ 'PAYMENT_INFO.MIN_SPEND.5_PARAG' | translate }}</p>
    <p>{{ 'PAYMENT_INFO.MIN_SPEND.6_PARAG' | translate }}</p>

    <div class="ion-float-left clickable" style="margin-top:20px;">
      <ion-button style="font-size: 12px;" class="ion-float-right" fill="outline" color="primary" (click)="onCancel();" class="btn--large ion-no-margin">{{ 'CONFIRM_TERMS.GROUPS.BTN_CANCEL' | translate }}</ion-button>
      <p style="color:blue; text-align: center;">{{ 'CONFIRM_TERMS.GROUPS.UNDER_BTN_LINK' | translate }}</p>
    </div>

    <div class="ion-float-right clickable" style="margin-top:20px;">
      <ion-button style="font-size: 12px;" class="ion-float-right" color="primary" (click)="confirmTerms();" class="btn--large ion-no-margin">{{ 'CONFIRM_TERMS.GROUPS.BTN_OK' | translate }}</ion-button>
    </div>

  </div>

  <div *ngIf="noShowRequired && groupsConfirmationRequired">

    <h2>{{ 'CONFIRM_TERMS.GROUPS_AND_NO_SHOW.TITLE' | translate }}</h2>

    <p>{{ 'CONFIRM_TERMS.GROUPS_AND_NO_SHOW.1_PARAG' | translate }}</p>
    <p style="font-weight: bold;">{{ 'CONFIRM_TERMS.GROUPS_AND_NO_SHOW.2_PARAG' | translate }}</p>
    <p>{{ 'CONFIRM_TERMS.GROUPS_AND_NO_SHOW.3_PARAG' | translate }}</p>
    <h5 style="color: #444444; font-weight: bold;">{{ 'CONFIRM_TERMS.GROUPS_AND_NO_SHOW.NO_SHOW_TITLE' | translate }}</h5>
    <p>{{ 'CONFIRM_TERMS.GROUPS_AND_NO_SHOW.4_PARAG' | translate }}</p>
    <p>{{ 'CONFIRM_TERMS.GROUPS_AND_NO_SHOW.5_PARAG' | translate: { noShowMaxPenaltyPerPerson: noShowMaxPenaltyPerPerson } }}</p>

    <h5 style="color: #444444; font-weight: bold;">{{ 'CONFIRM_TERMS.NO_SHOW.CANCELATION_TITLE' | translate }}</h5>

    <p style="color: #444444; font-weight: bold;">{{ 'CONFIRM_TERMS.GROUPS_AND_NO_SHOW.6_PARAG' | translate : { cancellationPeriodInHours: cancellationPeriodInHours } }}</p>
    <p>{{ 'CONFIRM_TERMS.GROUPS_AND_NO_SHOW.7_PARAG' | translate }}</p>
    <p>{{ 'CONFIRM_TERMS.GROUPS_AND_NO_SHOW.8_PARAG' | translate }}</p>

    <div class="ion-float-left clickable" style="margin-top:20px;">
      <ion-button style="font-size: 12px;" class="ion-float-right" fill="outline" color="primary" (click)="onCancel();" class="btn--large ion-no-margin">{{ 'CONFIRM_TERMS.GROUPS.BTN_CANCEL' | translate }}</ion-button>
      <p style="color:blue; text-align: center;">{{ 'CONFIRM_TERMS.GROUPS.UNDER_BTN_LINK' | translate }}</p>
    </div>

    <div class="ion-float-right clickable" style="margin-top:20px;">
      <ion-button style="font-size: 12px;" class="ion-float-right" color="primary" (click)="confirmTerms();" class="btn--large ion-no-margin">{{ 'CONFIRM_TERMS.GROUPS.BTN_OK' | translate }}</ion-button>
    </div>

  </div>

  <div *ngIf="paymentRequired && groupsConfirmationRequired">

    <h2>{{ 'CONFIRM_TERMS.GROUPS_AND_PAYMENT.TITLE' | translate }}</h2>

    <p>{{ 'CONFIRM_TERMS.GROUPS_AND_PAYMENT.1_PARAG' | translate }}</p>
    <p style="font-weight: bold;">{{ 'CONFIRM_TERMS.GROUPS_AND_PAYMENT.2_PARAG' | translate }}</p>
    <p>{{ 'CONFIRM_TERMS.GROUPS_AND_PAYMENT.3_PARAG' | translate }}</p>
    <h5 style="color: #444444; font-weight: bold;">{{ 'CONFIRM_TERMS.GROUPS_AND_PAYMENT.NO_SHOW_TITLE' | translate }}</h5>
    <p>{{ 'CONFIRM_TERMS.GROUPS_AND_PAYMENT.4_PARAG' | translate }}</p>
    <p>{{ 'CONFIRM_TERMS.GROUPS_AND_PAYMENT.5_PARAG' | translate: { paymentAmount: paymentAmount } }}</p>

    <h5 style="color: #444444; font-weight: bold;">{{ 'CONFIRM_TERMS.NO_SHOW.CANCELATION_TITLE' | translate }}</h5>

    <p style="color: #444444; font-weight: bold;">{{ 'CONFIRM_TERMS.GROUPS_AND_PAYMENT.6_PARAG' | translate : { cancellationPeriodInHours: cancellationPeriodInHours } }}</p>
    <p>{{ 'CONFIRM_TERMS.GROUPS_AND_PAYMENT.7_PARAG' | translate }}</p>
    <p>{{ 'CONFIRM_TERMS.GROUPS_AND_PAYMENT.8_PARAG' | translate }}</p>

    <div class="ion-float-left clickable" style="margin-top:20px;">
      <ion-button style="font-size: 12px;" class="ion-float-right" fill="outline" color="primary" (click)="onCancel();" class="btn--large ion-no-margin">{{ 'CONFIRM_TERMS.GROUPS.BTN_CANCEL' | translate }}</ion-button>
      <p style="color:blue; text-align: center;">{{ 'CONFIRM_TERMS.GROUPS.UNDER_BTN_LINK' | translate }}</p>
    </div>

    <div class="ion-float-right clickable" style="margin-top:20px;">
      <ion-button style="font-size: 12px;" class="ion-float-right" color="primary" (click)="confirmTerms();" class="btn--large ion-no-margin">{{ 'CONFIRM_TERMS.GROUPS.BTN_OK' | translate }}</ion-button>
    </div>

  </div>

  <div *ngIf="minSpendRequired && groupsConfirmationRequired">

    <h2>{{ 'CONFIRM_TERMS.GROUPS_AND_MIN_SPEND.TITLE' | translate }}</h2>

    <p>{{ 'CONFIRM_TERMS.GROUPS_AND_MIN_SPEND.1_PARAG' | translate }}</p>
    <p style="font-weight: bold;">{{ 'CONFIRM_TERMS.GROUPS_AND_MIN_SPEND.2_PARAG' | translate }}</p>
    <p>{{ 'CONFIRM_TERMS.GROUPS_AND_MIN_SPEND.3_PARAG' | translate }}</p>
    <h5 style="color: #444444; font-weight: bold;">{{ 'CONFIRM_TERMS.GROUPS_AND_MIN_SPEND.NO_SHOW_TITLE' | translate }}</h5>
    <p>{{ 'CONFIRM_TERMS.GROUPS_AND_MIN_SPEND.4_PARAG' | translate }}</p>
    <p>{{ 'CONFIRM_TERMS.GROUPS_AND_MIN_SPEND.5_PARAG' | translate: { minSpendAmountPerPerson: minSpendAmountPerPerson } }}</p>

    <h5 style="color: #444444; font-weight: bold;">{{ 'CONFIRM_TERMS.NO_SHOW.CANCELATION_TITLE' | translate }}</h5>

    <p style="color: #444444; font-weight: bold;">{{ 'CONFIRM_TERMS.GROUPS_AND_MIN_SPEND.6_PARAG' | translate : { cancellationPeriodInHours: cancellationPeriodInHours } }}</p>
    <p>{{ 'CONFIRM_TERMS.GROUPS_AND_MIN_SPEND.7_PARAG' | translate }}</p>
    <p>{{ 'CONFIRM_TERMS.GROUPS_AND_MIN_SPEND.8_PARAG' | translate }}</p>

    <div class="ion-float-left clickable" style="margin-top:20px;">
      <ion-button style="font-size: 12px;" class="ion-float-right" fill="outline" color="primary" (click)="onCancel();" class="btn--large ion-no-margin">{{ 'CONFIRM_TERMS.GROUPS.BTN_CANCEL' | translate }}</ion-button>
      <p style="color:blue; text-align: center;">{{ 'CONFIRM_TERMS.GROUPS.UNDER_BTN_LINK' | translate }}</p>
    </div>

    <div class="ion-float-right clickable" style="margin-top:20px;">
      <ion-button style="font-size: 12px;" class="ion-float-right" color="primary" (click)="confirmTerms();" class="btn--large ion-no-margin">{{ 'CONFIRM_TERMS.GROUPS.BTN_OK' | translate }}</ion-button>
    </div>

  </div>

</ion-content>